import { useTheatricalPromotionContext } from '@/views/TicketCheckoutViews/components/TheatricalPromotionContext'
import { NoFeesModal } from '../modals/NoFeesModal'
import CustomImageModal from './CustomImageModal'

const noFeesConfig = {
  modalType: 'no_fees',
  backgroundImage: {
    __typename: 'Asset',
    url: 'https://images.ctfassets.net/4jbwlym6m4be/5RWGUHtGjXIdSKazVCdSBU/bb95268157888c410a1fe97e8d640d41/david-no-fees-modal-bg.jpg',
    width: 1520,
    height: 1864,
  },
  accentColor: '#EA6F13',
}

const bogoConfig = {
  desktopImage: {
    url: '/v1763768326/david/default-promo/David_Black-Friday-Deal_BOGO_Modal_600x704',
    width: 600,
    height: 704,
  },
  mobileImage: {
    url: '/v1763768327/david/default-promo/David_Black-Friday-Deal_BOGO_Modal_320x556',
    width: 320,
    height: 556,
  },
}

const tenDollarConfig = {
  desktopImage: {
    url: '/v1763768253/david/default-promo/David_Black-Friday-Deal__10-TICKETS_Modal_600x704',
    width: 600,
    height: 704,
  },
  mobileImage: {
    url: '/v1763768253/david/default-promo/David_Black-Friday-Deal__10-TICKETS_Modal_320x556',
    width: 320,
    height: 556,
  },
}

const familyPack3Config = {
  desktopImage: {
    url: '/v1763768331/david/default-promo/David_Black-Friday-Deal_3-TICKET-FAMILY-PACK_Modal_600x704',
    width: 600,
    height: 704,
  },
  mobileImage: {
    url: '/v1763768332/david/default-promo/David_Black-Friday-Deal_3-TICKET-FAMILY-PACK_Modal_320x556',
    width: 320,
    height: 556,
  },
}

const familyPack4Config = {
  desktopImage: {
    url: '/v1763768329/david/default-promo/David_Black-Friday-Deal_4-TICKET-FAMILY-PACK_Modal_600x704',
    width: 600,
    height: 704,
  },
  mobileImage: {
    url: '/v1763768329/david/default-promo/David_Black-Friday-Deal_4-TICKET-FAMILY-PACK_Modal_320x556',
    width: 320,
    height: 556,
  },
}

const DavidDefaultPromoModal: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  const { experiments, publicDiscounts } = useTheatricalPromotionContext()

  const variation = experiments?.['david-default-promo'] ?? 'nofees'

  if (variation === 'nofees') {
    if (!publicDiscounts.noFeesDiscount) return null
    return (
      <NoFeesModal
        open={open}
        onClose={onClose}
        {...noFeesConfig}
        code={publicDiscounts.noFeesDiscount.code}
        noFeesDiscount={publicDiscounts.noFeesDiscount}
        backgroundIsDark={false}
      />
    )
  }

  if (variation === 'bogo') {
    return <CustomImageModal {...bogoConfig} alt="David Black Friday Deal - BOGO" open={open} onClose={onClose} />
  }

  if (variation === 'ten_dollar') {
    return (
      <CustomImageModal
        {...tenDollarConfig}
        alt="David Black Friday Deal - $10 Tickets"
        open={open}
        onClose={onClose}
      />
    )
  }

  if (variation === 'family_pack_3') {
    return (
      <CustomImageModal
        {...familyPack3Config}
        alt="David Black Friday Deal - 3 Ticket Family Pack"
        open={open}
        onClose={onClose}
      />
    )
  }

  if (variation === 'family_pack_4') {
    return (
      <CustomImageModal
        {...familyPack4Config}
        alt="David Black Friday Deal - 4 Ticket Family Pack"
        open={open}
        onClose={onClose}
      />
    )
  }

  return null
}

export default DavidDefaultPromoModal
